var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"yushu-user-avator",staticStyle:{"display":"inline-block"},style:(_vm.style)},[_c('img',{style:(_vm.style),attrs:{"src":_vm.Utils.getAvator(_vm.userId, _vm.size)}})])}
var staticRenderFns = []

export { render, staticRenderFns }